<div
  class="simple-pie d-inline-block"
  [ngClass]="{'p-3': this.autosize}"
  [ngStyle]="{
    'width': this.autosize ? 'auto':this.diameter+'px',
    'height': this.autosize ? 'auto':this.diameter+'px'
  }"
  style="filter: drop-shadow(0px 0px 5px #00000030);"
  [innerHTML]="svgHtml"
></div>